"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ImageWMS = _interopRequireDefault(require("ol/source/ImageWMS"));

var _EditLayerForm = _interopRequireDefault(require("../EditLayerForm/EditLayerForm.js"));

var _GeneralTab = _interopRequireDefault(require("../../tabs/general/GeneralTab/GeneralTab"));

var _ImageWMSSourceTab = _interopRequireDefault(require("../../tabs/source/ImageWMSSourceTab/ImageWMSSourceTab"));

var _common = require("../../../../../util/common");

var _defined = _interopRequireDefault(require("../../../../../core/defined"));

var _constants = require("../../../../../core/constants");

var _common2 = require("ol/source/common");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["source"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EditImageWMSLayerForm = function EditImageWMSLayerForm(_ref) {
  var layer = _ref.layer,
      onFinish = _ref.onFinish;
  var onInternalFinish = (0, _react.useCallback)(function (values) {
    values = (0, _common.resetObject)(values);

    if ((0, _defined.default)(values)) {
      var _values = values,
          source = _values.source,
          properties = _objectWithoutProperties(_values, _excluded);

      layer.setProperties(properties);

      if ((0, _defined.default)(source)) {
        if ((0, _defined.default)(layer.getSource) && layer.getSource() instanceof _ImageWMS.default) {
          layer.getSource().setUrl(source.url);

          if ((0, _defined.default)(source.params)) {
            if (!(0, _defined.default)(source.params.STYLES)) {
              source.params.STYLES = '';
            }

            if (!(0, _defined.default)(source.params.VERSION)) {
              source.params.VERSION = _common2.DEFAULT_WMS_VERSION;
            }

            if (!(0, _defined.default)(source.params.FORMAT)) {
              source.params.FORMAT = _constants.DEFAULT_WMS_IMAGE_FORMAT;
            }

            if (!(0, _defined.default)(source.params.FEATURE_COUNT)) {
              delete source.params.FEATURE_COUNT;
            }

            layer.getSource().updateParams(source.params);
          }
        }
      }
    } // normalizeStringInObject(values);
    // if(values.source) {
    //     normalizeStringInObject(values.source);
    //     if(values.source.params)
    //         normalizeStringInObject(values.source.params);
    // }
    // const {source, ...properties} = values;
    // layer.setProperties(properties);
    // if(source) {
    //     if(layer.getSource() instanceof OlImageWMSSource) {
    //         layer.getSource().setUrl(source.url);
    //         for(let key in source.params) {
    //             if(source.params[key] === "") {
    //                 source.params[key] = undefined;
    //             }
    //         }
    //         layer.getSource().updateParams(source.params);
    //     }
    // }
    //execute onFinish


    onFinish && onFinish(values);
  }, [layer, onFinish]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditLayerForm.default, {
    layer: layer,
    onFinish: onInternalFinish,
    tabs: [{
      title: "General",
      key: "general",
      isDefault: true,
      el: _GeneralTab.default
    }, {
      title: "Source",
      key: "source",
      el: _ImageWMSSourceTab.default
    }]
  });
};

var _default = EditImageWMSLayerForm;
exports.default = _default;